<template>
<q-layout view="lhh LpR lff">
    <q-page-container>
      <q-page padding>
        <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
        </div>
        <div class='row d-flex full-width'>
          <div v-for="(item,index) in categories" :key="index" class='col-12 col-sm-4 col-md-3 q-pa-md'>
            <q-btn class='full-width my-card relative-position' style="margin: 0 auto;overflow:hidden; color:white;min-height:150px" :color="item.backgroundColor" :to='item.ref'>
              <q-card-section class='full-width'>
                <div class='text-h5 text-right'>{{item.name}}</div>
                <!-- <div class='text-right'>{{ item.description }}</div> -->
              </q-card-section>
              <q-card-section class='text-left absolute q-my-xl' style='left:-8%;top:20%'>
                <q-icon :name='item.icon' style='font-size: 7em; opacity:0.3' />
              </q-card-section>
            </q-btn>
          </div>
        </div>
      </q-page>
    </q-page-container>
</q-layout>
</template>

<script>
export default {
  data() {
    return {
      categories: [{
        name: 'Nông trường',
        icon: 'filter_vintage',
        ref: '/categories/farms',
        backgroundColor: 'green'
        },
        {
        name: 'Công việc',
        icon: 'pan_tool',
        ref: '/categories/jobs',
        backgroundColor: 'red'
        },
        {
        name: 'Meka',
        icon: 'person',
        ref: '/categories/mekas',
        backgroundColor: 'blue'
        },
        {
        name: 'Dây Màu',
        icon: 'all_inclusive',
        ref: '/categories/ribbons',
        backgroundColor: 'purple'
        },
        {
        name: 'Nhân sự',
        icon: 'person',
        ref: '/categories/users',
        backgroundColor: 'pink'
        },
        ]
        // green - red -blue - purple
        //colors: ['#00a152', '#f44336', '#2196f3', '#9c27b0', '#00bcd4 ', '#ffeb3b', '#795548'],
    }
  },
  methods: {
    
  }
}
</script>
